@if (parsed(); as p) {
   @if (p.kind === 'generic') {
      <div
         (click)="openUrl()"
         class="flex items-center gap-3 rounded-lg border border-outline-variant bg-surface-container px-3 py-2 hover:bg-surface-container-high transition-colors"
      >
         <img
            [src]="p.faviconUrl"
            alt=""
            class="w-4 h-4"
         />
         <span class="text-sm font-medium flex-1 min-w-0 truncate">{{ p.domain }}</span>
         <fa-icon
            [icon]="['fas', 'arrow-up-right-from-square']"
            class="text-xs text-on-surface-variant"
         />
      </div>
   }

   @if (expanded() && (p.kind === 'google-drive' || p.kind === 'attachment-pdf')) {
      @if (loading()) {
         <mat-progress-bar
            [mode]="'indeterminate'"
            class="w-full mt-2"
         />
      } @else if (error(); as err) {
         <div class="flex flex-col items-center justify-center gap-2 rounded-lg border border-outline-variant mt-2 p-6 text-on-surface-variant">
            <fa-icon
               [icon]="['far', 'triangle-exclamation']"
               class="text-2xl text-error"
            />
            <span class="text-sm">{{ err | translate }}</span>
            <button
               (click)="fetchPdf(p)"
               mat-button
            >
               {{ 'general.retry' | translate }}
            </button>
         </div>
      } @else if (pdfData(); as data) {
         <kendo-pdfviewer
            (pageChange)="onPageChange($event)"
            [arrayBuffer]="data"
            [loadOnDemand]="true"
            [loadOnDemandPageSize]="2"
            [saveFileName]="saveFileName()"
            [tools]="['pager', 'spacer', 'zoom', 'zoomInOut', 'spacer', 'download']"
            class="w-full rounded-lg border border-outline-variant mt-2 aspect-16/10"
            zoom="fitToWidth"
         />
      }
   }
}
